import React, { useEffect, useRef, useState, useCallback } from "react";
import ReactDOM from "react-dom";
import { SubNavItem, ListItem, UL } from "./styles";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../popups/GetStartedPopup";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import {
  getHighlightStyles,
  getItemHighlightStyles,
  getItemHighlightTemplate,
} from "../setting/HighlightConstants";

const SubSidebar = ({ onMouseEnter, onMouseLeave, demo }) => {
  //------------------------------------------State and Variables Start------------------------------------------//

  let params = useParams();
  let ch = 1;
  const [navData1, setNavData1] = useState("iconclose");
  const [demographicsPopup, setDemographicsPopup] = useState(false);
  const [popupStep, setPopupStep] = useState(0);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const highlightRef = useRef(null);
  const [patFetched, setPatFetched] = useState(false);
  const [billFetched, setBillFetched] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const accRef1 = useRef(null);
  const popupRepositionFrameRef = useRef(null);
  const navScrollParentRef = useRef(null);
  const navScrollTopRef = useRef(0);
  const [popupPositionKey, setPopupPositionKey] = useState(0);

  const refreshPopupPosition = useCallback(() => {
    if (popupRepositionFrameRef.current) {
      cancelAnimationFrame(popupRepositionFrameRef.current);
    }

    popupRepositionFrameRef.current = requestAnimationFrame(() => {
      setPopupPositionKey((prev) => prev + 1);
    });
  }, []);

  const getScrollableParent = useCallback((element) => {
    let parent = element?.parentElement;

    while (parent) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      const canScroll =
        (overflowY === "auto" || overflowY === "scroll") &&
        parent.scrollHeight > parent.clientHeight;

      if (canScroll) {
        return parent;
      }

      parent = parent.parentElement;
    }

    return null;
  }, []);
  var accountType =
    localStorage.getItem("account_type") &&
    Decrypt_Value(localStorage.getItem("account_type"), "vozo");

  var NavData1 = useSelector((state) => state.Schedule?.NavData);
  var SideNavData = useSelector((state) => state.Schedule?.SideNavData);
  //------------------------------------------State and Variables End------------------------------------------//
  // ------------------------------- Functions Start--------------------------------------------------------- //

  const handleInputChange = (iconName) => (e) => {
    dispatch(GetNav(iconName));
  };

  // const showNextStep = (popupStep) => {
  //   setDemographicsPopup(false);
  //   if (popupStep === "22") {
  //     history.replace({
  //       pathname: "/patient/billandinsurance/1",
  //       search: `?step=22.2`,
  //     });
  //     return;
  //   }
  //   history.replace({
  //     pathname: "/patient/demographics/1",
  //     search: `?step=${popupStep}.2`,
  //   });
  // };

  const showNextStep = (popupStep) => {
    setDemographicsPopup(false);

    if (popupStep === "billing-membership.4") {
      setPopupStep(0);
      history.replace({
        pathname: `/patient/demographics/${params.pid}`,
        search: "?step=billing-membership.5",
      });
      return;
    }

    if (popupStep === "23.4") {
      setPopupStep(0);
      history.push({
        pathname: location.pathname,
        search: "?step=23.5",
      });
      return;
    }

    if (popupStep === "26") {
      history.replace({
        pathname: `/patient/treatmentplan/${params.pid}`,
        search: `?step=26.2`,
      });
      return;
    }

    if (popupStep === "27") {
      history.replace({
        pathname: `/patient/careplan/${params.pid}`,
        search: `?step=27.2`,
      });
      return;
    }

    if (popupStep === "33") {
      history.replace({
        pathname: `/patient/flowsheet/${params.pid}`,
        search: `?step=33.2`,
      });
      return;
    }

    if (popupStep === "22") {
      history.replace({
        pathname: `/patient/billandinsurance/${params.pid}`,
        search: `?step=22.2`,
      });
      return;
    }

    if (popupStep === "19" || popupStep === "21") {
      history.replace({
        pathname: `/patient/insuranceCoverage/${params.pid}`,
        search: `?step=${popupStep}.2`,
      });
      return;
    }

    if (popupStep === "34") {
      history.replace({
        pathname: `/patient/imaging/${params.pid}`,
        search: "?step=34.2",
      });
      return;
    }

    history.replace({
      pathname: `/patient/demographics/${params.pid}`,
      search: `?step=${popupStep}.2`,
    });
  };
  const menuItems = [
    {
      label: "Patient Dashboard",
      path: `patientdashboard/${params.pid}`,
      top: true,
    },
    { label: "Demographics", path: `demographics/${params.pid}` },
    { label: "Care Summary", path: `CareSummary/${params.pid}` },
    // Insurance Coverage
    { label: "Insurance Coverage", path: `insuranceCoverage/${params.pid}` },
    { label: "Appointment", path: `appointment/${params.pid}` },
    { label: "Encounter Notes", path: `encounternotes/${params.pid}` },
    { label: "Bill and Insurance", path: `billandinsurance/${params.pid}` },
    { label: "Flow Sheet", path: `flowsheet/${params.pid}` },
    { label: "Documents", path: `documents/${params.pid}` },
    { label: "Billing History", path: `billinghistory/${params.pid}` },
    { label: "Care Plan", path: `careplan/${params.pid}` },
    { label: "Treatment Plan", path: `treatmentplan/${params.pid}` },
    { label: "Risk Assessment", path: `riskassessment/${params.pid}` },
    { label: "Measures", path: `measures/${params.pid}` },
    // { label: "Monitoring & Tasks", path: `monitoring/${params.pid}` },
    { label: "Problems", path: `problems/${params.pid}` },
    { label: "Allergies", path: `allergies/${params.pid}` },
    { label: "Medication", path: `medication/${params.pid}` },
    { label: "Immunizations", path: `immunization/${params.pid}` },
    { label: "Family History", path: `familyhistory/${params.pid}` },
    { label: "Past Medical History", path: `pastmedicalhistory/${params.pid}` },
    { label: "Episode Management", path: `episodemanagement/${params.pid}` },
    { label: "Growth Chart", path: `growthchart/${params.pid}` },
    { label: "Lab Order", path: `procedureorder/${params.pid}` },
    { label: "Imaging", path: `imaging/${params.pid}` },
    { label: "E-Prescriptions", path: `senderx/${params.pid}/${ch}` },
    { label: "Client Portal Access", path: `clientportalaccess/${params.pid}` },
  ];

  // ------------------------------- Functions End--------------------------------------------------------- //
  // ------------------------------- UseEffect Start ------------------------------------------------------- //

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);
  useEffect(() => {
    dispatch(GetNav("iconclose"));
  }, []);

  useEffect(() => {
    if (demographicsPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [demographicsPopup]);

  // Keep patient sidebar above backdrop so highlighted item can escape it
  useEffect(() => {
    if (
      demographicsPopup &&
      (popupStep === "22" ||
        popupStep === "21" ||
        popupStep === "26" ||
        popupStep === "27")
    ) {
      const patLeftDiv = document.querySelector(".pat-left-div");

      if (patLeftDiv) patLeftDiv.style.zIndex = "10000";

      return () => {
        if (patLeftDiv) patLeftDiv.style.zIndex = "";
      };
    }
  }, [demographicsPopup, popupStep]);

  useEffect(() => {
    const handlePatFetchDone = (e) => {
      if (e.detail === true) {
        setPatFetched(true);
      }
    };

    window.addEventListener("patFetchDone", handlePatFetchDone);

    return () => {
      window.removeEventListener("patFetchDone", handlePatFetchDone);
    };
  }, []);

  useEffect(() => {
    const handleBillFetchDone = (e) => {
      if (e.detail.billdetail === true) {
        // Delay state update to allow layout to settle
        setTimeout(() => {
          setBillFetched(true);
        }, 150); // Adjust delay if needed
      }
    };

    window.addEventListener("BillFetchDone", handleBillFetchDone);

    return () => {
      window.removeEventListener("BillFetchDone", handleBillFetchDone);
    };
  }, []);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");
    // if (
    //   step === "19" ||
    //   (patFetched && step === "20") ||
    //   step === "21" ||
    //   (step === "22" && billFetched)
    // ) {
    if (
      step === "19" ||
      (patFetched && step === "20") ||
      step === "21" ||
      (step === "22" && billFetched) ||
      step === "34" ||
      step === "26" ||
      step === "27" ||
      step === "33" ||
      step === "23.4" ||
      step === "billing-membership.4"
    ) {
      if (step === "19" && accountType === "1") {
        setDemographicsPopup(true);
        query.delete("step");
        history.replace({
          pathname: location.pathname,
          search: query.toString(),
        });
        return;
      }
      // if (billFetched && step === "22"){
      //   setDemographicsPopup(true);
      //   query.delete("step");
      //   history.replace({
      //     pathname: location.pathname,
      //     search: query.toString(),
      //   });
      //   return;
      // }
      // if (patFetched && step === "20"){
      //   setDemographicsPopup(true);
      //   query.delete("step");
      //   history.replace({
      //     pathname: location.pathname,
      //     search: query.toString(),
      //   });
      //   return;
      // }
      setPopupStep(step); // Save step in state
      setTimeout(() => {
        if (highlightRef.current) {
          highlightRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 400);
      if (accRef1.current) {
        accRef1.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        const rect = accRef1.current.getBoundingClientRect();
        const isVisible =
          rect.top >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight);

        const delay = isVisible ? 100 : 630;

        setTimeout(() => {
          setDemographicsPopup(true);
        }, delay);
      }

      setTimeout(() => {
        setDemographicsPopup(true);
      }, 1000);
      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, [location?.search, patFetched, billFetched]);

  useEffect(() => {
    if (isInitialLoad) {
      const timeout = setTimeout(() => setIsInitialLoad(false), 200); // small delay
      return () => clearTimeout(timeout);
    }
  }, [isInitialLoad]);

  useEffect(() => {
    if (demographicsPopup) {
      setIsInitialLoad(true);
    }
  }, [demographicsPopup]);

  useEffect(() => {
    if (popupStep && highlightRef.current) {
      highlightRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [popupStep, demographicsPopup]);

  useEffect(() => {
    const pendingStep = localStorage.getItem(
      "billingMembershipTourPendingStep",
    );

    if (pendingStep === "4" && params.pid) {
      localStorage.removeItem("billingMembershipTourPendingStep");

      setPopupStep("billing-membership.4");
      setIsInitialLoad(false);

      setTimeout(() => {
        setDemographicsPopup(true);
      }, 300);
    }
  }, [params.pid]);

  useEffect(() => {
    return () => {
      if (popupRepositionFrameRef.current) {
        cancelAnimationFrame(popupRepositionFrameRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (
      !demographicsPopup ||
      !(
        popupStep === "19" ||
        popupStep === "20" ||
        popupStep === "21" ||
        popupStep === "22" ||
        popupStep === "26" ||
        popupStep === "27"
      )
    )
      return;

    const handlePositionUpdate = () => {
      refreshPopupPosition();
    };

    handlePositionUpdate();

    window.addEventListener("resize", handlePositionUpdate);
    window.addEventListener("scroll", handlePositionUpdate, true);

    return () => {
      window.removeEventListener("resize", handlePositionUpdate);
      window.removeEventListener("scroll", handlePositionUpdate, true);
    };
  }, [demographicsPopup, popupStep, refreshPopupPosition]);

  useEffect(() => {
    if (
      !demographicsPopup ||
      !(
        popupStep === "19" ||
        popupStep === "20" ||
        popupStep === "21" ||
        popupStep === "22" ||
        popupStep === "26" ||
        popupStep === "27"
      )
    )
      return;
    let cleanupScrollLock = null;

    const timer = setTimeout(() => {
      const scrollParent = getScrollableParent(highlightRef.current);

      if (!scrollParent) return;

      navScrollParentRef.current = scrollParent;
      navScrollTopRef.current = scrollParent.scrollTop;

      const previousOverflowY = scrollParent.style.overflowY;
      const previousOverscrollBehavior = scrollParent.style.overscrollBehavior;

      scrollParent.style.overflowY = "hidden";
      scrollParent.style.overscrollBehavior = "contain";

      const lockScroll = (e) => {
        const isZoomGesture =
          e.ctrlKey || e.metaKey || (e.touches && e.touches.length > 1);

        if (isZoomGesture) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (navScrollParentRef.current) {
          navScrollParentRef.current.scrollTop = navScrollTopRef.current;
        }
      };

      const keepScrollFixed = () => {
        if (navScrollParentRef.current) {
          navScrollParentRef.current.scrollTop = navScrollTopRef.current;
        }
      };

      scrollParent.addEventListener("wheel", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("touchmove", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("scroll", keepScrollFixed, true);

      cleanupScrollLock = () => {
        scrollParent.removeEventListener("wheel", lockScroll, true);
        scrollParent.removeEventListener("touchmove", lockScroll, true);
        scrollParent.removeEventListener("scroll", keepScrollFixed, true);

        scrollParent.style.overflowY = previousOverflowY;
        scrollParent.style.overscrollBehavior = previousOverscrollBehavior;

        navScrollParentRef.current = null;
      };
    }, 450);

    return () => {
      clearTimeout(timer);

      if (cleanupScrollLock) {
        cleanupScrollLock();
      }
    };
  }, [demographicsPopup, popupStep, getScrollableParent]);

  // ------------------------------- UseEffect End ------------------------------------------------------- //

  const getPopupContent = (step) => {
    const contentMap = {
      19: {
        title: "Add Patients Insurance",
        description:
          "Go to Patient > Patient List > Insurance Coverage menu to add insurance details.",
        bullets: [
          "Check Eligibility of the patient for coverage.",
          "Send insurance claim for the patients to the insurance payer.",
        ],
        currentStep: 1,
        totalSteps: 4,
      },
      20: {
        title: "Complete Patient Demographics",
        description:
          "Go to Patient > Patient List > Demographics menu to enter demographics details of the patients.",
        currentStep: 1,
        totalSteps: 2,
      },
      21: {
        title: "Check Coverage Details",
        description:
          "Go to Patient > Patient List > Insurance Coverage menu to check eligibility verification details.",
        currentStep: 1,
        totalSteps: 5,
      },
      22: {
        title: "Add Patients Credit Card",
        description:
          "Go to Patient > Patient List > Bill & Insurance menu to add the credit card information of the patients.",
        currentStep: 1,
        totalSteps: 3,
      },
      34: {
        title: "Add Image Types",
        description:
          "Go to Patient > Patient List > Imaging Menu to add and view imaging orders, results, and tests.",
        currentStep: 1,
        totalSteps: 7,
      },
      26: {
        title: "Create New Treatment Plan",
        description:
          "Go to Patient > Patient List > Treatment Plan menu to create new treatment plan for the patients.",
        currentStep: 1,
        totalSteps: 6,
      },
      27: {
        title: "Create New Care Plan",
        description:
          "Go to Patient > Patient List > Care Plan menu to create new care plan for the patients.",
        currentStep: 1,
        totalSteps: 6,
      },
      33: {
        title: "Vitals Flowsheet",
        description:
          "Go to Patient > Patient List > Flowsheet Menu to check the vitals and forms",
        currentStep: 1,
        totalSteps: 6,
      },
      23.4: {
        title: "Assign Membership Plan to Patient",
        description:
          "To assign Membership plan navigate to Patient > Patient List > Select a patient > Go to Patient Demographics menu.",
        currentStep: 4,
        totalSteps: 8,
      },
      "billing-membership.4": {
        title: "Assign Membership Plan to Patient",
        description:
          "Go to Patient > Demographics menu to assign a membership plan to the patient.",
        bullets: [],
        currentStep: 4,
        totalSteps: 8,
      },
      default: {
        title: "Get Started",
        description: "Please select an option to continue.",
        bullets: [],
        currentStep: 1,
        totalSteps: 3,
      },
    };

    return contentMap[step] || contentMap.default;
  };

  return (
    <div ref={accRef1}>
      <UL
        backgroundColor="white"
        position="relative"
        top="0px"
        listStyleType="none"
        padding="0 0 16px 0"
        marginBottom={
          (SideNavData === "demo" ||
            SideNavData !== "demographics") &&
          "0px !important"
        }
        width={
          (demo === "demo" && navData1 === "iconopen" && "92.6%") ||
          (demo === "dashboard" && navData1 === "iconopen" && "92.6%") ||
          (navData1 === "iconclose" && "92.6%")
        }
        borderTop="1px solid rgba(46, 46, 46, 0.25)"
        height={
          SideNavData === "demo"
            ? "fit-content"
            : "100%"
        }
        textAlign="left"
        paddingLeft="20px"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        borderRadius="0 0 10px 10px"
      >
        {menuItems.map((item, index) => {
          // if (
          //   (popupStep === "20" && item.label === "Demographics") ||
          //   ((popupStep === "19" || popupStep === "21") &&
          //     item.label === "Insurance Coverage") ||
          //   (popupStep === "22" && item.label === "Bill and Insurance")
          // ) {
          if (
            ((popupStep === "20" ||
              popupStep === "23.4" ||
              popupStep === "billing-membership.4") &&
              item.label === "Demographics") ||
            ((popupStep === "19" || popupStep === "21") &&
              item.label === "Insurance Coverage") ||
            (popupStep === "22" && item.label === "Bill and Insurance") ||
            (popupStep === "34" && item.label === "Imaging") ||
            (popupStep === "26" && item.label === "Treatment Plan") ||
            (popupStep === "27" && item.label === "Care Plan") ||
            (popupStep === "33" && item.label === "Flow Sheet")
          ) {
            const content = getPopupContent(popupStep);

            return (
              <ListItem
                key={index}
                width="100%"
                margin={item.top ? "2px 0 0 -10px" : "2px 0 0 -10px"}
                padding="8px 10px"
                onClick={handleInputChange("iconclose")}
                style={{
                  position: "relative",
                  ...getHighlightStyles(demographicsPopup),
                  zIndex: demographicsPopup ? 10001 : "auto",
                }}
                className={demographicsPopup ? "highlight-sidebar" : ""}
                ref={highlightRef}
              >
                <Popup
                  key={`patient-subnav-tour-${popupStep}-${popupPositionKey}`}
                  style={{
                    zIndex: 10002,
                  }}
                  offset={
                    popupStep === "19"
                      ? [78, 15]
                      : popupStep === "20"
                        ? [40, 20]
                        : popupStep === "21"
                          ? [35, 15]
                          : popupStep === "22"
                            ? [45, 15]
                            : popupStep === "26"
                              ? [35, 15]
                              : popupStep === "27"
                                ? [37, 15]
                                : popupStep === "33"
                                  ? [40, 15]
                                  : popupStep === "34"
                                    ? [30, 20]
                                    : popupStep === "23.4" ||
                                        popupStep === "billing-membership.4"
                                      ? [40, 20]
                                      : [10, 50]
                  }
                  content={
                    <GetStartedPopup
                      title={content?.title}
                      description={
                        <div>
                          {content?.description}
                          {content?.bullets?.length > 0 && (
                            <>
                              <br />
                              <div style={{ marginTop: "5px" }}>
                                By doing so you can:
                              </div>
                            </>
                          )}
                        </div>
                      }
                      bullets={
                        Array.isArray(content?.bullets) ? content.bullets : []
                      }
                      currentStep={content?.currentStep || 1}
                      totalSteps={content?.totalSteps || 1}
                      onNext={() => showNextStep(popupStep)}
                      width={
                        popupStep === "19"
                          ? "320px"
                          : popupStep === "20"
                            ? "360px"
                            : popupStep === "22"
                              ? "300px"
                              : "340px"
                      }
                      onBack={
                        popupStep === "23.4"
                          ? () => {
                              setDemographicsPopup(false);
                              setPopupStep(0);
                              history.push({
                                pathname: "/patient/membershipplan",
                                search: "?step=23.3",
                              });
                            }
                          : popupStep === "billing-membership.4"
                            ? () => {
                                setDemographicsPopup(false);
                                setPopupStep(0);
                                history.replace({
                                  pathname: "/patient/membershipplan",
                                  search: "?step=billing-membership.3",
                                });
                              }
                            : undefined
                      }
                      onClose={() => {
                        setDemographicsPopup(false);
                        setPopupStep(0);
                      }}
                      closeOnOutsideClick={true}
                      arrowPosition="left-top"
                      showBackdrop={
                        popupStep !== "22" &&
                        popupStep !== "21" &&
                        popupStep !== "26" &&
                        popupStep !== "27"
                      }
                    />
                  }
                  open={demographicsPopup}
                  className="centerarrowpopup no-sui-arrow m-t-10"
                  popperModifiers={[
                    {
                      name: "eventListeners",
                      enabled: true,
                      options: { scroll: true, resize: true },
                    },
                    { name: "flip", enabled: false },
                    {
                      name: "preventOverflow",
                      enabled: popupStep !== "20",
                      options: {
                        boundary: "viewport",
                        padding: 8,
                      },
                    },
                    {
                      name: "computeStyles",
                      enabled: true,
                      options: {
                        adaptive: false,
                      },
                    },
                  ]}
                  mountNode={document.getElementById("root") || document.body}
                  trigger={
                    <SubNavItem
                      to={{
                        pathname: `/patient/${item.path}`,
                      }}
                      exact
                      activeClassName="active"
                      className={`${demographicsPopup ? "highlight" : ""}`}
                      style={{
                        display: "block",
                        width: "100%",
                        position: "relative",
                        ...getItemHighlightStyles(demographicsPopup),
                        zIndex: demographicsPopup ? 10001 : "auto",
                        backgroundColor:
                          demographicsPopup && popupStep === "22"
                            ? "#ffffff"
                            : undefined,
                        borderRadius:
                          demographicsPopup && popupStep === "22"
                            ? "4px"
                            : undefined,
                      }}
                    >
                      {item.label}
                    </SubNavItem>
                  }
                  position="right center"
                />
              </ListItem>
            );
          } else {
            return (
              <ListItem
                key={index}
                width="100%"
                margin={item.top ? "2px 0 0 -10px" : "2px 0 0 -10px"}
                padding="8px 10px"
                onClick={handleInputChange("iconclose")}
              >
                <SubNavItem
                  to={{
                    pathname: `/patient/${item.path}`,
                  }}
                  exact
                  activeClassName="active"
                >
                  {item.label}
                </SubNavItem>
              </ListItem>
            );
          }
        })}
      </UL>
      {demographicsPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor:
              popupStep === "21" ||
              popupStep === "22" ||
              popupStep === "26" ||
              popupStep === "27"
                ? "rgba(0, 0, 0, 0.35)"
                : "transparent",
            zIndex:
              popupStep === "21" ||
              popupStep === "22" ||
              popupStep === "26" ||
              popupStep === "27"
                ? 9999
                : 999,
            pointerEvents: "auto",
          }}
          onClick={() => setDemographicsPopup(false)}
        />
      )}
    </div>
  );
};

export default SubSidebar;
